var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResaleFinishedProduct(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000"
    },
    d: "M405.413,512H106.586c-32.785,0-59.459-26.674-59.459-59.46V59.46C47.127,26.674,73.801,0,106.586,0 h298.827c32.787,0,59.46,26.674,59.46,59.46v189.575c0,7.869-6.381,14.249-14.249,14.249s-14.249-6.381-14.249-14.249V59.46 c0-17.071-13.889-30.961-30.961-30.961H106.586c-17.071,0-30.96,13.889-30.96,30.961v393.08c0,17.071,13.889,30.961,30.96,30.961 h298.827c17.071,0,30.961-13.889,30.961-30.961V330.999c0-7.869,6.381-14.249,14.249-14.249s14.249,6.381,14.249,14.249V452.54 C464.873,485.326,438.199,512,405.413,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M110.506,14.249h45.37v145.527c0,6.69-6.801,11.229-12.98,8.664l-30.276-12.577 c-2.304-0.958-4.893-0.958-7.197,0L75.147,168.44c-6.177,2.566-12.98-1.974-12.98-8.664V62.585 C62.17,35.89,83.811,14.249,110.506,14.249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000"
    },
    d: "M146.504,183.418c-3.116,0-6.169-0.613-9.073-1.817l-28.408-11.801l-28.408,11.801 c-2.904,1.206-5.956,1.817-9.071,1.817c-13.027,0-23.624-10.604-23.624-23.641v-97.19C47.922,28.076,75.997,0,110.507,0h45.37 c7.87,0,14.249,6.381,14.249,14.249v145.527C170.127,172.81,159.53,183.416,146.504,183.418z M109.024,140.897 c3.125,0,6.174,0.607,9.06,1.805l23.543,9.779V28.499h-31.121c-18.795,0-34.086,15.291-34.086,34.088v89.896l23.539-9.778 C102.85,141.504,105.899,140.897,109.024,140.897z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M169.007,282.542c0,0,0.087-0.103,0.247-0.288c-10.868,0.033-25.27,2.089-34.478,11.298 c-16.411,16.411-10.11,49.319-10.11,49.319s32.908,6.301,49.319-10.11c9.135-9.135,11.231-23.383,11.296-34.22 C175.006,289.65,169.007,282.542,169.007,282.542z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000"
    },
    d: "M139.246,358.31c-0.001,0-0.001,0-0.003,0c-9.446,0-16.484-1.294-17.256-1.443 c-5.734-1.097-10.218-5.582-11.317-11.314c-0.789-4.127-7.11-40.937,14.03-62.075c10.064-10.064,25.457-15.415,44.511-15.471 c0.014,0,0.028,0,0.041,0c5.234,0,10.019,2.867,12.504,7.415c2.338,2.522,6.787,7.101,12.849,12.346 c3.149,2.726,4.949,6.693,4.925,10.858c-0.113,18.916-5.462,34.206-15.469,44.213C173.94,352.959,158.443,358.31,139.246,358.31z M137.754,329.796c0.487,0.01,0.983,0.014,1.49,0.014c11.311,0,20.07-2.529,24.666-7.125c3.649-3.649,6-9.946,6.81-18.063 c-3.228-2.995-5.899-5.667-7.94-7.793c-8.05,0.821-14.295,3.166-17.927,6.798C138.855,309.626,137.61,321.07,137.754,329.796z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M185.281,266.543c-0.064-10.838-2.16-25.085-11.296-34.22c-16.411-16.411-49.319-10.11-49.319-10.11 s-6.301,32.909,10.11,49.319c9.208,9.208,23.61,11.266,34.478,11.298c-0.161-0.185-0.247-0.288-0.247-0.288 S175.006,275.435,185.281,266.543z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000"
    },
    d: "M169.255,297.078c-0.014,0-0.028,0-0.041,0c-19.054-0.056-34.447-5.406-44.512-15.471 c-21.139-21.139-14.819-57.948-14.03-62.075c1.099-5.733,5.582-10.217,11.315-11.314c0.772-0.148,7.809-1.443,17.258-1.443 c19.198,0,34.696,5.349,44.817,15.471c10.007,10.009,15.357,25.298,15.469,44.213c0.024,4.165-1.775,8.132-4.925,10.858 c-6.059,5.244-10.508,9.822-12.85,12.35C179.271,294.214,174.487,297.078,169.255,297.078z M137.74,235.288 c-0.154,8.856,1.154,20.209,7.112,26.166c3.632,3.632,9.878,5.976,17.927,6.798c2.041-2.126,4.712-4.799,7.94-7.793 c-0.809-8.115-3.161-14.413-6.81-18.064c-4.594-4.594-13.355-7.123-24.666-7.123C138.733,235.273,138.231,235.278,137.74,235.288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M388.521,282.829c0,0-48.628,69.241-108.612,69.241s-108.612-69.241-108.612-69.241 s48.628-69.241,108.612-69.241S388.521,282.829,388.521,282.829z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000"
    },
    d: "M279.909,366.319c-66.625,0-118.114-72.226-120.274-75.301c-3.451-4.913-3.451-11.465,0-16.378 c2.16-3.075,53.649-75.301,120.274-75.301c66.623,0,118.114,72.226,120.273,75.301c3.451,4.913,3.451,11.465,0,16.378 C398.021,294.094,346.532,366.319,279.909,366.319z M189.364,282.813c14.198,17.087,50.252,55.009,90.544,55.009 c40.446,0,76.381-37.871,90.544-54.974c-14.201-17.088-50.256-55.009-90.544-55.009 C239.462,227.839,203.528,265.71,189.364,282.813z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000"
    },
    d: "M303.736,440.254h-95.471c-7.87,0-14.249-6.381-14.249-14.249s6.379-14.249,14.249-14.249h95.471 c7.869,0,14.249,6.381,14.249,14.249S311.604,440.254,303.736,440.254z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResaleFinishedProduct);
export default __webpack_public_path__ + "static/media/resale_finished_product.bc10da9a4def99caef3099c76f4c4356.svg";
export { ForwardRef as ReactComponent };